<!-- Notification button -->
<div class="notification-container">
    <!-- The unread count lives in the aria-label (same convention as the
         library header's built-in bell), so the badge and icon are hidden
         from assistive tech to avoid double-reading. -->
    <button
        (click)="openNotificationDropdown($event)"
        class="vb-header-icon-btn"
        [attr.aria-label]="bellAriaLabel"
        [attr.aria-expanded]="toggleService.getToggleState('isNotificationDropdownOpen')"
        aria-haspopup="true">
        <vb-icon name="bell" [size]="22" [strokeWidth]="1.6" aria-hidden="true"></vb-icon>
        <span class="vb-header-badge" aria-hidden="true" *ngIf="totalCount">{{ !isMobile ?totalCount>99? '99+':totalCount: null }}</span>
    </button>

    <!-- Notification dropdown -->
    <!-- Show notification dropdown if open -->
    <div *ngIf="toggleService.getToggleState('isNotificationDropdownOpen')">
        <!-- Title row with an explicit close X — outside-click dismissal is
             unreliable on mobile, where the tap usually activates whatever
             sits under it. Shared by both dropdown states. -->
        <ng-template #dropdownHead>
            <div class="vb-dropdown-eyebrow notification-head">
                <span>Notifications</span>
                <button
                    type="button"
                    class="notification-close"
                    aria-label="Close notifications"
                    (click)="closeNotificationDropdown($event)">
                    <vb-icon name="close" [size]="16" [strokeWidth]="1.8" aria-hidden="true"></vb-icon>
                </button>
            </div>
        </ng-template>
        <!-- If notifications exist -->
        <div
            *ngIf="notificationMessages.length > 0"
            class="vb-dropdown-panel notification-dropdown"
            role="region"
            aria-label="Notifications">
            <ng-container [ngTemplateOutlet]="dropdownHead"></ng-container>
            <div class="notification-messages" (scroll)="onNotificationScroll($event)">
                <!-- The row markup (icon · title/description · date) is
                     generated by notificationTemplate() — the title lives in
                     there, so nothing else renders it here. -->
                <div
                    *ngFor="let messageObj of notificationMessages"
                    class="notification-text"
                    (click)="navToNotification($event, messageObj?.url)"
                    (keyup)="navToNotification($event, messageObj?.url)"
                    [tabindex]="messageObj?.url ? 0 : null"
                    [innerHTML]="sanitizeHtml(messageObj.message)"></div>
                <div *ngIf="isLoadingMore" class="vb-spinner-box vb-spinner-box--inline">
                    <vb-spinner size="sm" label="Loading more"></vb-spinner>
                </div>
            </div>

            <!-- Clear all notifications -->
            <button
                class="notification-footer"
                aria-label="Clear all notifications"
                (click)="clearNotifications()">
                Clear All
            </button>
        </div>

        <!-- If no notifications -->
        <div
            *ngIf="notificationMessages.length === 0"
            class="vb-dropdown-panel notification-dropdown">
            <ng-container [ngTemplateOutlet]="dropdownHead"></ng-container>
            <div class="notification-empty">No new notifications</div>
        </div>
    </div>
</div>
